/**
 * Storyella 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const storyellaPaymentConfig: BrandPaymentConfig = {
  brand: 'storyella',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/storyella/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/storyella/vip_bg.webp',
      memberSubscribeBg: '/images/storyella/member_subscribe_bg.webp',
      vipIcon: '/images/storyella/vip_icon2.png',
      vipDiscountIcon: '/images/storyella/vip_discount.png',
      discountBg: '/images/storyella/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(90deg, #FF6734 0.03%, #FF42CC 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #FFCAA8 0%, #FFE0CC 70%, #FFF8F5 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #FF6734, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF4774',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFF0F3',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #FFCAA8 0%, #FFE0CC 70%, #FFF8F5 100%)',
      pinkGradient: 'linear-gradient(90deg, #FF6734 0.03%, #FF42CC 100%)',
      memberSubscribeBg: '/images/storyella/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
